<template>
    <div>
        <div v-if="specialSelection == 'None'">
            there are {{perkCount}} perks in Akashic Paths
            <v-row>            
                <v-col sm="4">
                    <br/>Perks have 3 main types:
                    <ul>
                        <li><a @click="scrollTo('martial')">Martial</a></li>
                        <li><a @click="scrollTo('magic')">Magic</a></li>
                        <li><a @click="scrollTo('universal')">Universal</a></li>
                    </ul>
                </v-col>
                <v-col sm="4">
                    <br/>5 Rare Types:
                    <ul>
                        <li><a @click="scrollTo('fighterPerks')" >Fighter Perks</a></li>
                        <li><a @click="scrollTo('ragePerks')">Rage Powers</a></li>
                        <li><a @click="scrollTo('roguePerks')">Rogue Talents</a></li>
                        <li><a @click="scrollTo('kiPerks')">Ki Powers</a></li>
                        <li><a @click="scrollTo('gambits')">Warlord Gambits</a></li>
                        <li><a @click="scrollTo('recoveryPerks')">Recovery Perks</a></li>
                    </ul>
                </v-col>
                <v-col sm="4">
                    <br/>5 Rarities:
                    <ul>
                        <li>Common</li>
                        <li>Rare</li>
                        <li>Epic</li>
                        <li>Legendary</li>
                        <li>Unique</li>
                    </ul>
                </v-col>
            </v-row>
            <br/>There is also one ultrarare type of perk called a forbidden perk, they are not listed here.
            <br/>
            <div v-for="type in types" :key="type">
                <h2 :id="type" style="color:cornflowerblue">{{type[0].toUpperCase() + type.substr(1)}} Perks:</h2>
                <div v-for="rarity in rarities" :key="rarity">
                    <h3>{{rarity[0].toUpperCase() + rarity.substr(1)}}:</h3>
                    <table>
                        <tr> <th>Name</th><th style="padding-left:4px; padding-right:4px">Prerequisite</th><th>From Class</th><th>Description</th></tr>
                        <tr v-for="perk in sortedPerks(rarity, type)" :key="perk.name"> <td style="text-align:center" :id="`${perk.name}`">{{perk.name}}</td><td style="padding-left:4px; padding-right:4px">{{perk.prereq}}</td><td style="padding-left:4px">{{perk.fromClass}}</td><td style="padding-left:4px">{{perk.shortDesc}} <span v-if="perk.hasSpecialItems"><br/><br/><button style="color:blue; background:none; border:none;"  @click="setSpecialSelections(perk)">Click to See Perk Special Selection</button></span></td></tr>
                    </table>           
                    <br/>
                </div>
            </div>

        <div v-for="type in rareTypes" :key="type">
                <h2 :id="type" style="color:cornflowerblue">{{filterString(type)}} Perks:</h2>
                <table>
                    <tr> <th>Name</th><th>Description</th></tr>
                    <tr v-for="perk in sortedPerks('blank', type)" :key="perk.name"> <td style="text-align:center" :id="`${perk.name}`">{{perk.name}}</td><td style="padding-left:4px">{{perk.shortDesc}}</td></tr>
                </table>           
                <br/>
            </div>

            <div>
                <h2 id='gambits' style="color:cornflowerblue">Gambits</h2>
                <table>
                    <tr> <th>Name</th><th>requirement</th><th>Bonus</th></tr>
                    <tr v-for="perk in rarePerkTypes.gambits" :key="perk.name"> <td style="text-align:center">{{perk.name}}</td><td style="padding-left:4px">{{perk.requirement}}</td><td style="padding-left:4px">{{perk.bonus}}</td></tr>
                </table>           
                <br/>
            </div>
        </div>
        <div v-else id="top">
            <v-btn text class="pa-0" style="position:fixed; width:50px;right:25px;bottom:50px" @click="clearSpecialSelection"><v-img style="width:50px;"  :src="require('../../../assets/Mini_skip reversed.png')"></v-img></v-btn>
            <h1 style="color:cornflowerblue">{{specialSelection.name}}:</h1
            >There are {{specialSelectionItems.length}} sub perks apart of {{specialSelection.name}}
            <table style="width:100%">
                <tr>
                    <th >Name</th>
                    <th v-if="specialSelectionItems[0].type">Type</th>
                    <th>Description</th>                
                </tr>
                <tr v-for="item in specialSelectionItems" :key="item.name"> 
                    <td style="padding-left:4px; padding-right:4px; text-align:center">{{item.name}}</td>
                    <td v-if="specialSelectionItems[0].type" style="padding-left:4px; padding-right:4px; text-align:center">
                        <span>
                            <span v-if="item.type && item.type.length == 1">{{item.type[0]}}</span>
                            <span v-else v-for="type in item.type" :key="type">{{type}}, </span>
                        </span>
                    </td>
                    <td style="padding-left:4px">{{item.description}}</td>
                </tr>
            </table>  
        </div>
        <v-icon v-if="specialSelection == 'None'" style="position:fixed; right:16px; bottom:16px; color:cornflowerblue" outlined large @click="scrollTo('top')">mdi-arrow-up-circle</v-icon>
    </div>
</template>
<script>
//
import {perks, fighterPerks, ragePerks, roguePerks, kiPerks, gambits, recoveryPerks} from "../../../play/data"


// import PickerCard from '../../../play/PickerCard.vue';
export default {
  components: {    
    // PickerCard
  },
  props:{
      type:Object,
      perkList:String
  },
  data(){
      return{
          perkCount: 0,
          rarePerkTypes:{
              fighterPerks:fighterPerks,
              ragePerks:ragePerks,
              roguePerks:roguePerks,
              kiPerks:kiPerks,
              gambits:gambits,
              recoveryPerks:recoveryPerks,
          },
          rarities:["common","rare","epic","legendary","unique"],
          types:["martial","magic","universal"],
          rareTypes:["fighterPerks","ragePerks","roguePerks","kiPerks","recoveryPerks"],
          specialSelection:"None",
          specialSelectionItems:[],
      }
  },
  mounted(){
    this.perkCount = [].concat(fighterPerks,ragePerks,roguePerks,kiPerks,gambits,perks).length
    let params = new URLSearchParams(location.search)
    let perkList = params.get('perkList')
    if(perkList){
        let allPerks = [].concat(fighterPerks,ragePerks,roguePerks,kiPerks,gambits,perks,recoveryPerks)
        let perk = allPerks.find(perk=> perk.name == perkList)
        this.setSpecialSelections(perk)
    } 
  },
  methods:{
      sortedPerks(rarity, type){
          let allPerks = []
          let sortedPerks = []
          if(this.types.includes(type)){
                allPerks = [...perks]
                sortedPerks = allPerks.filter(perk=>perk.rarity == rarity && perk.type == type && perk.prereq != "special")
            }else{
                sortedPerks = this.rarePerkTypes[type].filter(perk=> perk.prereq != "special")
            }            
            let sorted = sortedPerks.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
            return sorted
      },
      filterString(str){
          let remove = str.replace("Perks","")
          let newStr = remove[0].toUpperCase() + remove.substring(1)
          return newStr

      },
      scrollTo(id){
        if(id == 'top'){
            window.scrollTo({top: 0, behavior: 'instant'});
        }else{
            let element = document.getElementById(id);
            let y = element.getBoundingClientRect().top - 64;
            window.scrollTo({top: y, behavior: 'smooth'});
        }
      },    

      setSpecialSelections(perk){
        this.specialSelection = perk
        this.specialSelectionItems = perk.getSpecialItemList(perk)
        this.$nextTick(()=>{
            this.scrollTo("top")
        })
        window.history.replaceState(null, null, "?type=Perks&perkList=" + perk.name)
      },

      clearSpecialSelection(){        
        let name = this.specialSelection.name
        this.$nextTick(()=>{
            window.scrollTo({top: 0, behavior: 'instant'});
            this.$nextTick(()=>{
                this.scrollTo(name)
            })           
        })
        this.specialSelection = 'None'
        window.history.replaceState(null, null, "?type=Perks")
      }
  }
}
</script>
<style scoped>
table, th, td {
  border:1px solid black;
}
</style>